import React from 'react';
import PropTypes from 'prop-types';

import Cards from './components/Cards';

const TransactionsData = (props) => {
  const { transactionsData, loadingState } = props;

  return (
    <div className="transactions-filters">
      <div className="form-header">
        <h4>Report Data</h4>
      </div>
      <Cards transactionsData={transactionsData} loadingState={loadingState} />
    </div>
  );
};

export default TransactionsData;

TransactionsData.propTypes = {
  transactionsData: PropTypes.shape({
    transactionsCount: PropTypes.number.isRequired,
    depositsAmount: PropTypes.number.isRequired,
    expensesAmount: PropTypes.number.isRequired,
  }),
  loadingState: PropTypes.string.isRequired,
};

TransactionsData.defaultProps = {
  transactionsData: null,
};
